import {Component, OnInit, ViewEncapsulation, ViewChild, Output, EventEmitter, Input, Self, Optional} from '@angular/core';
import moment, { Moment } from 'moment';
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';
import {NgControl, ControlValueAccessor} from '@angular/forms';

interface DateRange {
  startDate: Moment;
  endDate: Moment;
}

const DAYS_OF_WEEK_SHORT = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const DATE_FORMAT = 'MM/DD/YYYY';
export const BUTTON_LOCATIONS: {
  INSIDE: 'inside';
  OUTSIDE: 'outside';
} = {
  INSIDE: 'inside',
  OUTSIDE: 'outside'
};
type ValueOf<T> = T[keyof T];


@Component({
  selector: 'app-date-range',
  templateUrl: './app-date-range.component.html',
  styleUrls: ['./app-date-range.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppDateRangeComponent implements OnInit, ControlValueAccessor {
  @Input() testId;
  @Input() public showLabel: boolean;
  @Input() public showRanges = false;
  @Input() label?: string;
  @Input() rangeClass?: string;
  @Input() isRequired?: boolean;
  @Input() buttonClearLabel?: string;
  @Input() isDisabled = false;
  @Input() buttonLocation: ValueOf<typeof BUTTON_LOCATIONS> = 'outside';

  @Output() public rangeSelected: EventEmitter<Event> = new EventEmitter<Event>();
  @ViewChild(DaterangepickerDirective) ngxDaterangepickerMd: any;

  @ViewChild(DaterangepickerDirective, {static: true}) private pickerDirective: DaterangepickerDirective;

  public get selected(): {startDate: Moment; endDate: Moment} {
    return this.ctrl?.control?.value;
  }

  public ranges = {};
  public locale: any = {
    separator: ' - ',
    format: DATE_FORMAT,
    daysOfWeek: DAYS_OF_WEEK_SHORT
  };
  public readonly BUTTON_LOCATIONS = BUTTON_LOCATIONS;

  public onChange: (value: DateRange) => void;
  public onTouched: () => void;

  constructor(@Self() @Optional() public ctrl?: NgControl) {
    if (this.ctrl) {
      this.ctrl.valueAccessor = this;
    }
  }

  writeValue(value: any): void {}

  registerOnChange(fn: (value: DateRange) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    this.ranges = this.showRanges
      ? {
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(1, 'month').add(1, 'day'), moment()],
          'Last 90 Days': [moment().subtract(3, 'month').add(1, 'day'), moment()],
          'Last Year': [moment().subtract(1, 'year').add(1, 'day'), moment()]
        }
      : {};
  }

  public onChangeApply(e: Event): void {
    if (!(e instanceof Event)) {
      return;
    }
    if (!(e as any).target.value.length) {
      this.clear();
      return;
    }

    const dateString = (e as any).target.value.split(this.locale.separator);
    const start = moment(dateString[0], this.locale.format);
    const end = dateString.length < 2 ? moment(dateString[0], this.locale.format) : moment(dateString[1], this.locale.format);

    if (!start.isValid() || !end.isValid() || start > end) {
      this.ctrl?.control?.setErrors({incorrectDate: true});
      return;
    }

    this.ctrl?.control?.setValue({
      startDate: start,
      endDate: end
    });
  }

  public onModelChange(e: Event): void {
    this.rangeSelected.emit(e);
  }

  public openCalendar(): void {
    if (!this.isDisabled) {
      this.pickerDirective.open();
    }
  }

  public clear(): void {
    this.ctrl.reset();
  }
}
